const PRODUCTS_OPTIONS_VALUE_GLOBALWIFI_ID = -10002;

const RENTAL_IS_UNDERSTOCK = 'rental_understock';

const leftPaddingForDateFormat = num => num < 10 ? '0' + num : num;


const isObject = target => target !== null && typeof target === 'object';


const copyObject = obj => JSON.parse(JSON.stringify(obj));


const getNumOfDaysThisMonth = (month, year) => {
    if (month === 2) {
        return (year % 4) ? 28 : 29;
    }
    return ~[1, 3, 5, 7, 8, 10, 12].indexOf(month) ? 31 : 30
};

//new Date cross browser
const makeDate = date => {

    if (!date) return new Date();

    if (typeof date === 'string') {
        return date.match(/-/g).length === 1 ? new Date(date) : new Date(date.replace(/-/g, '/'));
    }

    return new Date(date);
};


const transformDateFomatToYMD = datestring => {
    const dt = makeDate(datestring);
    return dt.getFullYear() + '-' + leftPaddingForDateFormat(dt.getMonth() + 1) + '-' + leftPaddingForDateFormat(dt.getDate());
};


const transformDateFomatToYM = datestring => {
    const dt = makeDate(datestring);
    return dt.getFullYear() + '-' + leftPaddingForDateFormat(dt.getMonth() + 1);
};


const getLastDateInTheMonth = datestring => {
    let dt = makeDate(datestring);
    const y = dt.getFullYear(),
        m = dt.getMonth() + 1,
        d = getNumOfDaysThisMonth(m, y);

    const ndt = new Date(y, m - 1, d);
    return transformDateFomatToYMD(ndt);
};


const anyTruthyValueInObj = obj => {
    for (let prop in obj) {
        if (obj[prop]) return true;
    }
    return false;
};



export default {
    PRODUCTS_OPTIONS_VALUE_GLOBALWIFI_ID,
    RENTAL_IS_UNDERSTOCK,
    copyObject,

    makeDate,

    transformDateFomatToYMD,

    transformDateFomatToYM,

    getLastDateInTheMonth,

    anyTruthyValueInObj

}


// WEBPACK FOOTER //
// ./src/util.js